import { connect } from 'react-redux';
import { message } from 'antd';
import RankingHeader from './RankingHeader';
import { selectRankingDetails } from '@selectors/ranking';
import { actions as PageAction } from '@pages/names';

import { removeRanking } from '../../service/ranking';

export const showEditModal = () => (dispatch, getState) => {
  let { rankingDetails: { name } } = getState();
  dispatch({ type: 'CREATE_RANKING_NAME', payload: name });
  dispatch({ type: 'CREATE_RANKING_VISIBLE', payload: true });
};

export const remove = () => (dispatch, getState) => {
  const state = getState();
  const { _id, isPartnerGroup, isOwner } = selectRankingDetails(state);
  const { jwToken } = state;

  if (isPartnerGroup && !isOwner) {
    return Promise.resolve();
  }

  return removeRanking(jwToken, _id)
    .then(() => {
      dispatch({ type: 'RANKING_DETAILS_REMOVED', meta: { _id } });
      dispatch({ type: PageAction.MyRankings });
    })
    .catch((error) => {
      const msg =
        error?.response?.data?.message ||
        'No se pudo completar la operación';
      message.error(msg);
      return Promise.reject(error);
    });
};

export const mapStateToProps = state => selectRankingDetails(state);
export const mapDispatchToProps = dispatch => ({
  onAddParticipants: () =>
    dispatch({ type: 'RANKING_PARTICIPANTS_VISIBLE', payload: true }),
  onEditName: () => dispatch(showEditModal()),
  onRemoveRanking: () => dispatch(remove())
});

export default connect(mapStateToProps, mapDispatchToProps)(RankingHeader);
